import { useLocation } from "react-router-dom";
import * as React from "react";
import TraceView from "./components/Views/TraceView";
import ProductView from "./components/Views/ProductView";
import { useOrgDetails } from "./Hooks/useOrgDetails";

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function Trace() {
    let query = useQuery();
    const trace_item = query.get("trace_item_id") || undefined;
    const product_id = query.get("product_id") || undefined
    const org_id = query.get("org_id") || undefined;
    const isEmbedded = window.self !== window.top;
    const { orgInfo } = useOrgDetails(org_id, product_id);
    const REDIRECT_ENABLED_PRODUCT_IDS = process.env.REACT_APP_REDIRECT_ENABLED_PRODUCT_IDS?.split(",") || [];

    // Trace View 
    if (trace_item) {
        return <TraceView />;
    }

    // Product View
    if (org_id && product_id) {

        // This is a custom solution to particular org, since they are using old QR codes.
        if (!isEmbedded && REDIRECT_ENABLED_PRODUCT_IDS.includes(product_id) && orgInfo?.isCustomTracePage) {
            const apiUrl = `${process.env.REACT_APP_TRACE_REDIRECTION_URL}?org_id=${encodeURIComponent(org_id)}&product_id=${encodeURIComponent(product_id)}`;
            window.location.href = apiUrl;
            return null;
        }
        return <ProductView product_id={product_id} org_id={org_id} />;
    }

    // Redirect to tralexho.com if invalid query params
    window.location.href = "https://tralexho.com/";
    return null;
}
